<template>
    <div> 
        <v-simple-table
            class="bordered-table"
        >
            <tr>
                <td colspan="2" class="font-weight-bold">Dados do corretor</td>
            </tr>
            <tr>
                <td>Nome:</td>
                <td style="width: 90%">
                    {{ setColaborators }}
                </td>
            </tr>
        </v-simple-table>
        
        
        <br />
        <v-simple-table
            class="bordered-table"
        >
            <tr>
                <td colspan="2" class="font-weight-bold">Dados do imóvel</td>
            </tr>
            <tr>
                <td>Endereço:</td>
                <td style="width: 90%">
                    COD IMOVEL: {{ item.property.codigo }} - 
                    
                    {{ item.property.endereco }}
                    <span v-if="item.property.numero">, {{ item.property.numero }} </span>
                    <span v-if="item.property.apartamento"> - Apto: {{ item.property.apartamento }} </span>
                    <span v-if="item.property.complemento"> - Compl: {{ item.property.complemento }} </span>
                    <span v-if="item.property.bairro">  - {{ item.property.bairro }} </span>
                    <span v-if="item.property.cidade">  - {{ item.property.cidade }} </span>
                    <span v-if="item.property.estado">  - {{ item.property.estado }} </span>
                    <span v-if="item.property.cep">  - {{ item.property.cep | VMask('#####-###') }} </span>
                </td>
            </tr>
        </v-simple-table>   

        <br>
        <v-simple-table
            class="bordered-table"
        >
            <tr>
                <td class="font-weight-bold">Dados do proprietários</td>
            </tr>
            <tr>
                <td>
                    <v-card
                        class="mx-auto"
                        outlined
                    >
                        <v-data-table
                            :headers="headers_owners"
                            :items="item.property.property_owners_with_clients"
                            hide-default-footer
                        >
                            <template v-slot:[`item.nome`]="{ item }">
                                <span :class="$css_report_list">{{ item.nome }}</span>
                            </template>

                            <template v-slot:[`item.telefone`]="{ item }">
                                <phone-component v-if="item.telefone" :object="item.telefone"></phone-component> 
                                <phone-component v-if="item.telefone2" :object="item.telefone2"></phone-component>
                            </template>

                            <template v-slot:[`item.email`]="{ item }">
                                <span :class="$css_report_list">{{ item.email }}</span>
                            </template>

                        </v-data-table>
                    </v-card>
                </td>
            </tr>
        </v-simple-table>
        
        <br>
        <v-simple-table
            class="bordered-table"
        >
            <tr>
                <td class="font-weight-bold">Dados do proponente</td>
            </tr>
            <tr>
                <td>
                    <v-card
                        class="mx-auto"
                        outlined
                    >
                        <v-data-table
                            :headers="headers"
                            :items="item.residents"
                            hide-default-footer
                        >
                            <template v-slot:[`item.tipopessoa`]="{ item }">
                                <span>
                                    <span v-if="item.cpf">{{ item.cpf | VMask(maskCpfCnpj(item.cpf)) }}</span>
                                    <span v-if="item.cnpj">{{ item.cnpj | VMask(maskCpfCnpj(item.cnpj)) }}</span>
                                </span>
                            </template>
                            
                            <template v-slot:[`item.nome`]="{ item }">
                                <span>{{ item.nome }}</span>
                            </template>

                            <template v-slot:[`item.principal`]="{ item }">
                                <span>{{ item.principal }}</span>
                            </template>

                            <template v-slot:[`item.parentesco`]="{ item }">
                                <span>{{ item.parentesco }}</span>
                            </template>
                        </v-data-table>
                    </v-card>
                </td>
            </tr>
        </v-simple-table>

        <br />
        <v-simple-table
            class="bordered-table"
        >
            <tr>
                <td colspan="2" class="font-weight-bold">Dados da proposta</td>
            </tr>
            <tr>
                <td>Status: </td>
                <td>
                    <span>
                        <v-chip
                            :color="item.status | statusProposal"
                            label
                            text-color="black"
                            class="font-weight-medium text-h7"
                        >
                            {{ item.status }}
                        </v-chip> 
                    </span>
                </td>
            </tr>
            <tr>
                <td>Valor da proposta:</td>
                <td style="width: 85%">
                    {{ item.valor_proposta | toCurrency }}
                    - Comissão:
                    {{ item.comissao }} %
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    {{ item.proposta }}
                </td>
            </tr>
        </v-simple-table>


    </div>
</template>

<script>
import PhoneComponent from '@/components/phone/PhoneComponent.vue';

export default {
    components: {
        PhoneComponent
    },

    props: {
        object: {
            type: Object, 
            required: true,
            default: () => ({})
        },
    }, 

    watch: {
        object: {
            handler(newVal) {
                // Atualiza o objeto local se o pai atualizar
                this.item = JSON.parse(JSON.stringify(newVal));
            },
            deep: true, // Observa mudanças profundas
            immediate: true // Executa imediatamente ao montar
        }
    },

    computed: {
        me () {
            return this.$store.state.auth.me
        },

        hasData() {
            return this.object && Object.keys(this.object).length > 0;
        },

        valorProposta() {
            return Math.trunc(this.item.valor_proposta || 0)
        },

        residentPrincipal() {
            if (!Array.isArray(this.item.residents)) return ''

            const principais = this.item.residents.filter(resident => resident.principal === "Sim")
            
            return principais.map(resident => resident.nome).join(', ') || ''
        },

        setColaborators() {
            if (!Array.isArray(this.item.colaborators)) return ''
            
            return this.item.colaborators.map(colab => colab.name).join(', ') || ''
        },
    }, 

    data () {
        return {
            item: {},

            headers: [
                { text: 'DOCUMENTO', value: 'tipopessoa' },
                { text: 'NOME', value: 'nome' },
                { text: 'PRINCIPAL', value: 'principal' },
                { text: 'PARENTESCO / RELAÇÃO',  value: 'parentesco' }
            ],

            headers_owners: [
                { text: 'NOME', align: 'start', value: 'nome', },
                { text: 'TELEFONE', value: 'telefone' },
                { text: 'EMAIL', value: 'email' }
            ],
        }
    },
}
</script>

<style scoped>
.bordered-table {
  border-collapse: collapse;
  width: 100%;
}

.bordered-table th,
.bordered-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.bordered-table th {
  background-color: #f5f5f5;
}
</style>